import React, { useState } from "react";
import {
  Fab,
  Drawer,
  RadioGroup,
  FormControlLabel,
  FormControl,
  Divider,
  Box,
  Typography,
  Tooltip,
  useTheme,
} from "@mui/material";
//@ts-ignore
import FeatherIcon from "feather-icons-react";
import { IStoreState, useAppDispatch, useAppSelector } from "../../../redux";
import {
  changeCustomizerDarkModeSync,
  changeCustomizerDirSync,
  changeCustomizerNavbarBgSync,
} from "../../../redux/customizer";
import { CustomRadio } from "../../../Components/formComponents";

const SidebarWidth = "320px";

export const Customizer = () => {
  const theme = useTheme();
  const isLight = theme.palette.mode === "light";
  const isDarMode = false;
  const [showDrawer, setShowDrawer] = useState(false);
  const customizer = useAppSelector((state: IStoreState) => state.customizer);
  const dispatch = useAppDispatch();
  const thColors = [
    {
      id: 1,
      bgColor: "#FD7657",
      disp: "ORANGE_THEME",
    },
    {
      id: 2,
      bgColor: "#20232A",
      disp: "GRAY_THEME",
    },
    {
      id: 3,
      bgColor: "#FF6583",
      disp: "PINK_THEME",
    },
  ];

  return (
    <div>
      <Tooltip title="Settings">
        <Fab
          aria-label="settings"
          sx={{
            position: "fixed",
            right: "15px",
            bottom: "15px",
            zIndex: 1000,
            color: isLight
              ? "var(--text-light-color)"
              : "var(--text-dark-color)",
            backgroundColor: isLight
              ? "var(--secondary-color)"
              : "var(--primary-color)",
            "&:hover": {
              backgroundColor: isLight
                ? "var(--secondary-color)"
                : "var(--primary-color)",
            },
          }}
          onClick={() => setShowDrawer(true)}
        >
          <FeatherIcon icon="settings" />
        </Fab>
      </Tooltip>
      <Drawer
        anchor="right"
        open={showDrawer}
        onClose={() => setShowDrawer(false)}
        PaperProps={{
          sx: {
            width: SidebarWidth,
            backgroundColor:
              customizer.activeMode === "dark" ? "#121212" : "#fff",
          },
        }}
      >
        <Box p={2}>
          <Typography variant="h3">Settings</Typography>
        </Box>
        <Divider />
        <Box p={2}>
          {/* ------------ Dark light theme setting ------------- */}
          <Typography variant="h4" gutterBottom>
            Theme Option
          </Typography>
          <FormControl component="fieldset">
            <RadioGroup
              aria-label="theme"
              name="theme"
              value={customizer.activeMode}
              onChange={(event) =>
                dispatch(changeCustomizerDarkModeSync(event.target.value))
              }
            >
              <FormControlLabel
                value="light"
                control={<CustomRadio />}
                label="Light"
              />
              <FormControlLabel
                value="dark"
                control={<CustomRadio />}
                label="Dark"
              />
            </RadioGroup>
          </FormControl>
          <Box pt={3} />
          {/* ------------ RTL theme setting -------------*/}
          <Typography variant="h4" gutterBottom>
            Theme Direction
          </Typography>
          <FormControl component="fieldset">
            <RadioGroup
              aria-label="themedir"
              name="themedir"
              value={customizer.activeDir}
              onChange={(event) =>
                dispatch(changeCustomizerDirSync(event.target.value))
              }
            >
              <FormControlLabel
                value="ltr"
                control={<CustomRadio />}
                label="LTR"
              />
              <FormControlLabel
                value="rtl"
                control={<CustomRadio />}
                label="RTL"
              />
            </RadioGroup>
          </FormControl>
          <Box pt={3} />
          {/* ------------ Navbar Color setting ------------- */}
          <Typography variant="h4" gutterBottom>
            Theme Colors
          </Typography>
          {isDarMode &&
            thColors.map((thcolor) => (
              <Tooltip title={thcolor.disp} placement="top" key={thcolor.id}>
                <Fab
                  color="primary"
                  style={{ backgroundColor: thcolor.bgColor }}
                  sx={{ marginRight: "3px", marginBottom: 1 }}
                  size="small"
                  onClick={() => {
                    // dispatch(changeThemeSync(thcolor.disp));
                    document.documentElement.style.setProperty(
                      "--secondary-color",
                      thcolor.bgColor
                    );
                  }}
                  aria-label={thcolor.bgColor}
                >
                  {customizer.activeTheme === thcolor.disp ? (
                    <FeatherIcon icon="check" size="16" />
                  ) : (
                    ""
                  )}
                </Fab>
              </Tooltip>
            ))}

          <Box pt={3} />
        </Box>
      </Drawer>
    </div>
  );
};
